import React from "react";

import { convertIntegerToMoney } from "../../modules/helpers";
import Row from "../layout/row";

export const PayButton = ({
  gameType,
  hasWallet,
  hasPix,
  hasPreTicket,
  hasLogin,
  totalValue,
  selections = [],
  createTransaction,
}) => {
  const showButtons = () => {
    if (hasWallet) {
      return (
        <button
          type="button"
          className={`btn btn-primary submit-button  pull-right`}
          onClick={() => createTransaction(false, false)}
        >
          + Finalizar
          {totalValue > 0 && ` - R$ ${convertIntegerToMoney(totalValue)}`}
        </button>
      );
    }

    if (hasPreTicket) {
      return (
        <button
          type="button"
          className={`btn btn-primary pull-right submit-button`}
          onClick={() => createTransaction(true, false)}
        >
          Gerar pre-ticket
        </button>
      );
    }

    if (hasPix && !!totalValue /* && (selections || []).length > 0 */) {
      return hasLogin ? (
        <button
          type="button"
          className={`btn btn-primary pull-right submit-button sm-w-full`}
          onClick={() => createTransaction(false, true)}
        >
          Pagar Agora!
          {totalValue > 0 && ` - R$ ${convertIntegerToMoney(totalValue)}`}
        </button>
      ) : (
        <div style={{ color: "red " }}>
          <strong>
            Faça login no site de apostas para finalizar a compra.
          </strong>
        </div>
      );
    }
  };

  switch (gameType) {
    case "concurso":
      return (
        <div className="box-footer with-border">
          <Row>
            <div className="col-xs-12">{showButtons()}</div>
          </Row>
        </div>
      );

    case "loteria":
    default:
      return <div className="buttons-container-row">{showButtons()}</div>;
  }
};



// WEBPACK FOOTER //
// ./src/common/cart/payButton.jsx